import { createGtm } from '@gtm-support/vue-gtm';

export default createGtm({
  id: 'GTM-WP2WQ7T',
  queryParams: {},
  defer: false,
  compatibility: false,
  nonce: null,
  enabled: true,
  debug: false,
  loadScript: true,
  ignoredViews: [],
  trackOnNextTick: false,
});
